import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './AddScheduleMultipleModal.css';
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import TauriImage from '../../TauriImage/TauriImage';
import CheckboxOption from '../CheckboxOption/CheckboxOption';
import { activityClassification } from '../../../visualizations/visualizations';

const AddScheduleMultipleModal = ({ show, onHide, account, worksheet, isCreating, onProceed, selectedActivity, notes }) => {
    const [worksheetDays, setWorksheetDays] = useState([]);
    const [checkedDates, setCheckedDates] = useState({});

    const scheduleDates = {
        Suggested: [],
        Available: [],
        Selected: [],
    };

    // ✅ Always normalize to "YYYY-MM-DD" (Canada format)
    const normalizeDate = (date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d.toLocaleDateString("en-CA"); // e.g. "2025-09-01"
    };

    const getDateCategory = (date) => {
        const normalized = normalizeDate(date);

        if (scheduleDates?.Suggested?.some(d => normalizeDate(d) === normalized))
            return "suggested";

        if (scheduleDates?.Available?.some(d => normalizeDate(d) === normalized))
            return "available";

        if (scheduleDates?.Selected?.some(d => normalizeDate(d) === normalized))
            return "selected";

        return "default";
    };

    const handleCheckboxChange = (date) => {
        const normalized = normalizeDate(date);

        const max = account?.Customer?.Frequency_count || 0;
        const selectedCount = Object.values(checkedDates).filter(Boolean).length;
        const isChecked = !!checkedDates[normalized];

        if (!isChecked && selectedCount === max) return;

        setCheckedDates(prev => ({
            ...prev,
            [normalized]: !prev[normalized],
        }));
    };

    function formatDate(selectedDate) {
        if (!selectedDate) return "";
        return new Date(selectedDate).toLocaleDateString("en-US", {
            weekday: "long", // Wednesday
            month: "short",  // Aug
            day: "numeric",  // 19
            year: "numeric", // 2025
        });
    }

    const handleProceed = () => {
        const selectedDates = Object.keys(checkedDates).filter((date) => checkedDates[date]);

        // Exclude already selected ones
        const newDates = selectedDates.filter(
            (date) => !scheduleDates?.Selected?.some(d => normalizeDate(d) === date)
        );

        let payloads = [];

        if (selectedActivity?.Classification === activityClassification.Regular) {
            payloads = newDates.map((date) => ({
                Date: date,
                AccountID: account?.ID,
                ActivityID: selectedActivity.ID,
                Remarks: notes,
            }));
        } else {
            payloads = newDates.map((date) => ({
                Date: date,
                AccountID: account?.ID,
            }));
        }

        onProceed?.(payloads, selectedActivity);
    };

    useEffect(() => {
        if (worksheet?.Days && account?.ID) {
            const days = Object.keys(worksheet.Days);
            setWorksheetDays(days);

            // ✅ Pre-check only Selected (Suggested stays unchecked until user clicks)
            const preChecked = {};
            scheduleDates?.Selected?.forEach((day) => {
                preChecked[normalizeDate(day)] = true;
            });

            setCheckedDates(preChecked);
        }
    }, [worksheet, account]);


    return (
        <Modal
            className='add-schedule-multiple-modal'
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop={isCreating ? "static" : true}
            keyboard={!isCreating}
        >
            <Modal.Header>Add Schedule</Modal.Header>
            <Modal.Body>
                <div className="schedule-info">
                    <div className="schedule-step flex-shrink-0 me-3 me-md-2 me-lg-3">
                        {account?.Dates?.length || 0}/{account?.Customer?.Frequency_count || 0}
                    </div>
                    <div className="schedule-details">
                        <div className="account-code">{account?.Code}</div>
                        <div className="account-name">{account?.Name}</div>
                    </div>
                    <TauriImage localImage={"/Images/mdi--about-circle.svg"} alt='icon' color={"#B8CCE2"} />
                </div>

                <div className='schedule-instruction'>
                    Select the days you want this account to use the schedule.
                </div>

                <div className="schedule-options">
                    {worksheetDays.map((sd, idx) => {
                        const category = getDateCategory(sd);
                        const normalized = normalizeDate(sd);

                        return (
                            <CheckboxOption
                                key={idx}
                                label={formatDate(sd)}
                                checked={!!checkedDates[normalized]}
                                onChange={() => handleCheckboxChange(sd)}
                                category={category}
                            />
                        );
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <Button
                    className='btn-proceed d-flex align-items-center'
                    disabled={isCreating}
                    onClick={handleProceed}
                >
                    {isCreating && (
                        <TauriLoader2
                            width="1.2rem"
                            height="1.2rem"
                            borderwidth="0.2rem"
                            color="#1D5D9B"
                        />
                    )}
                    <span className="text-nowrap">Proceed</span>
                </Button>
                <Button className="btn-cancel d-flex" disabled={isCreating} onClick={onHide}>
                    <span className="text-nowrap">Cancel</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddScheduleMultipleModal;
